import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import ChangePasswordContainer from './ChangePasswordContainer';
import messages from '../../locale/jsonMessages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.changePasswordLabel);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout showSideMenu={'accountMenu'}><ChangePasswordContainer title={title} /></UserLayout>,
  };
};
